module.exports = __webpack_public_path__ + "img/mice.5409e818.png";